<template>
  <el-dialog :title="titleType" :visible.sync="brandVisible" width="30%">
    <el-form label-width="100px" class="dialogForm">
      <el-form-item label="所属品牌:" v-if="brandVisible">
        <el-cascader v-if="readOnlyBrandYesDropDown" v-model="chengshi" :options="options"
          @change="handleChange" placeholder="请选择" style="width: 80%" filterable clearable/>
        <el-input v-if="readOnlyBrandNoDropDown" v-model="modelStoresName"
          :disabled="true" style="width: 80%"/>
      </el-form-item>
    </el-form>
    <!-- 弹框按钮 确定/取消 -->
    <div class="preservation_div">
      <el-button @click="brandVisible = false"> 取消 </el-button>
      <el-button type="danger" v-if="titleType == '新增合作品牌'" @click="editSubmit()"> 确认 </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getBrandBusinessListExceptBeenSelected, getAddCooperatePartner } from "../../api/api";
export default {
  props:{
    cardId: { type:Number },
    cityIds:{
        type:Array,
        defaul:()=> []
    }
  },
  data() {
    return {
      brandVisible: false, // 新增合作品牌 & 编辑合作品牌 - 弹框
      titleType: "新增合作品牌", // title: 新增合作品牌 & 编辑合作品牌
      readOnlyBrandYesDropDown: true, // 新增有下拉数据的默认展示
      readOnlyBrandNoDropDown: false, // 编辑无下拉数据的默认隐藏消失
      modelStoresName: "", // 品牌 & 城市 & 店铺名称
      options: [],
      chengshi: "",
      modelBrandId: 0, // 品牌id
      cityId: 0, // 城市id
      brandBusinessId: 0, // 店铺id
      BrandName: "", // 品牌名称
      cityName: "", // 城市名称
      BbName: "", // 店铺名称
      isEddit: false, // 是否修改
      editStatus: "",
    };
  },
  methods: {
    // 初始化数据
    init(row, isEddit) {
      if (isEddit) {
        // 存在的话就是编辑进入的
        this.isEddit = isEddit;
        this.editStatus = row;
        this.titleType = "编辑合作品牌";
        this.readOnlyBrandYesDropDown = false; // 隐藏有下拉数据的
        this.readOnlyBrandNoDropDown = true; // 展示纯文本 状态并且置灰状态的
        this.modelStoresName =
          this.editStatus.BrandName +
          " / " +
          this.editStatus.CityName +
          " / " +
          this.editStatus.BbName; // 品牌/城市/店铺名称
        this.modelBrandId = this.editStatus.BrandId; // 品牌id
        this.cityId = this.editStatus.CityId; // 城市id
        this.brandBusinessId = this.editStatus.BbId; // 合作店铺id

        this.brandVisible = true;
        // this.isEddit=false;
        return;
      }
      if (row) {
        // 编辑
        this.editStatus = row;
        this.titleType = "编辑合作品牌";
        this.readOnlyBrandYesDropDown = false; // 隐藏有下拉数据的
        this.readOnlyBrandNoDropDown = true; // 展示纯文本 状态并且置灰状态的
        this.modelStoresName =
          this.editStatus.BrandName +
          " / " +
          this.editStatus.CityName +
          " / " +
          this.editStatus.BbName; // 品牌/城市/店铺名称
        this.modelBrandId = this.editStatus.BrandId; // 品牌id
        this.cityId = this.editStatus.CityId; // 城市id
        this.brandBusinessId = this.editStatus.BbId; // 合作店铺id
      } else {
        // 新增
        this.titleType = "新增合作品牌";
        this.readOnlyBrandYesDropDown = true; // 展示有下拉数据的
        this.readOnlyBrandNoDropDown = false; // 隐藏纯文本 状态并且置灰状态的
        (this.options = []),
        (this.chengshi = ""),
        this.getprovince();
      }
      this.brandVisible = true;
    },
    // 请选择所属品牌
    handleChange(val) {
      this.modelBrandId = val[0];
      this.cityId = val[1];
      this.brandBusinessId = val[2];
      this.BrandName = this.options.find((item) => item.value === val[0]).label;
      this.cityName = this.options
        .find((i) => i.value === val[0])
        .children.find((i) => i.value === val[1]).label;
      this.BbName = this.options
        .find((i) => i.value === val[0])
        .children.find((i) => i.value === val[1])
        .children.find((i) => i.value === val[2]).label;
    },
    // 查找品牌+城市+店铺
    getprovince() {
      var loginParams = {
        vipCardId: this.cardId, // 会员卡ID
        vipOpenCities: this.cityIds.map(item=>item[1]).join(","), // 已选择的城市, 以逗号分隔
      };
      getBrandBusinessListExceptBeenSelected(loginParams).then((data) => {
        let that = this;
        let provinceAndCityAndarea = [];
        data.ResultObj.map((item) => {
          // 所有品牌 查当前品牌下级市
          let provinceData = { value: item.Id, label: item.Name, children: [] };
          provinceAndCityAndarea.push(provinceData);
          // 所有市
          item.NodeList.map((city) => {
            let cityData = { value: city.Id, label: city.Name, children: [] };
            provinceData.children.push(cityData);
            // 店铺
            city.NodeList.map((zone) => {
              cityData.children.push({ value: zone.Id, label: zone.Name });
            });
          });
        });
        that.options = provinceAndCityAndarea;
      });
    },
    // 添加合作品牌
    editSubmit() {
      if (this.chengshi == "") {
        this.$swal({
          text: "请选择所属品牌",
          type: "warning",
        });
        return false;
      }
      let addParams = {
        VipCardId: this.cardId, // 会员卡ID
        BrandId: this.editStatus ? this.editStatus.BrandId : this.modelBrandId, // 品牌ID
        CityId: this.editStatus ? this.editStatus.CityId : this.cityId, // 城市ID
        BbId: this.editStatus ? this.editStatus.BbId : this.brandBusinessId, // 店铺ID

        BrandName: this.editStatus ? this.editStatus.BrandName : this.BrandName, // 品牌名称
        CityName: this.editStatus ? this.editStatus.CityName : this.cityName, // 城市名称
        BbName: this.editStatus ? this.editStatus.BbName : this.BbName, // 店铺名称
      };
      getAddCooperatePartner(addParams).then((r) => {
        if (r.ResultCode == 1) {
          this.brandVisible = false; // 新增合作品牌弹框
          this.$emit("refreshDataList", r.ResultObj);
        }
      });
    },
  },
};
</script>
<style scoped>
.preservation_div {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// addCooperativeBrand.vue?3d22a0b5